import PropTypes from "prop-types";
import { useState } from "react";
import { capture } from "../../../../services/posthogCapture";
import { WAITLIST_JOINED } from "../../../../services/posthogEvents.js";
import { validateEmail } from "../../../../util";
import { SuccessCheckIcon } from "../Icons.jsx";
import ms from "./ProductPage.module.css";
import { Button } from "../../../../themeV2";

WaitlistForm.propTypes = {
  productId: PropTypes.number,
  isVaulted: PropTypes.bool,
};

export default function WaitlistForm({ productId, isVaulted }) {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    if (success || loading) return;

    if (!validateEmail(email)) {
      setError("Please enter a valid email address");
      return;
    }
    if (email.endsWith(".con")) {
      setError("Check your email — did you mean .com?");
      return;
    }

    setLoading(true);
    try {
      const res = await window.fetch("/api/product/waitlist", {
        body: JSON.stringify({
          email: email.trim(),
          productId,
          source: "product_page",
          location: window.location.toString(),
        }),
        headers: { "content-type": "application/json" },
        method: "POST",
      });
      if (!res.ok) throw new Error("Failed");
      setSuccess(true);
      capture(WAITLIST_JOINED, {
        product_id: productId,
        is_vaulted: isVaulted,
      });
    } catch {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className={ms.waitlistSuccess} role="status">
        <SuccessCheckIcon className={ms.waitlistSuccessIcon} />
        <p className={ms.waitlistSuccessText}>
          You&apos;re on the list! We&apos;ll email you when this product is
          available.
        </p>
      </div>
    );
  }

  return (
    <div className={ms.waitlistForm}>
      <p className={ms.waitlistCopy}>
        {isVaulted
          ? "Join the wait list to be the first to know when this product is released from the vault."
          : "Join the wait list to be the first to know when this product is back in stock."}
      </p>
      <label className={ms.waitlistLabel} htmlFor="waitlist-email">
        Email address
      </label>
      <div className={ms.waitlistRow}>
        <input
          id="waitlist-email"
          className={ms.waitlistInput}
          type="email"
          autoComplete="email"
          placeholder="Enter your email address..."
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            setError("");
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleSubmit(e);
            }
          }}
          aria-invalid={Boolean(error)}
        />
        <Button
          size="sm"
          disabled={!email.trim()}
          loading={loading}
          onClick={handleSubmit}
        >
          Join Wait List
        </Button>
      </div>
      {error && (
        <p className={ms.waitlistError} role="alert">
          {error}
        </p>
      )}
      <p className={ms.waitlistPrivacy}>
        By entering your email, you agree to our{" "}
        <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>
        .
      </p>
    </div>
  );
}
